import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MsLogoComponent } from './ms-logo.component';

@NgModule({
  imports: [CommonModule],
  exports: [MsLogoComponent],
  declarations: [MsLogoComponent],
  providers: [],
})
export class MsLogoModule {}
